import React, { useContext, useState } from "react";
import { AudioContext } from "../context/AudioContext";

interface State {
  queue: Array<MediaElement>;
  assets: MediaAssets;
}

interface MediaAssets {
  [id: string]: MediaAsset;
}

interface MediaAsset {
  ref: any;
}

/**
 * Action Types
 */
enum ActionType {
  CLEAR = "CLEAR",
  INIT = "INIT",
  QUEUE = "QUEUE",
  PLAY = "PLAY",
  STOP = "STOP",
  REGISTER = "REGISTER",
}

interface MediaElement {
  ref: any;
}

interface Action {
  type: ActionType;
  data: ActionData;
}

interface ActionData {
  name?: string;
  id?: string;
  ref?: any;
}

/**
 * Reducer. This should be consumed by useImmerReducer()
 *
 * @param {*} draft
 * @param {*} action
 */
export const reducer = (draft: any, action: Action) => {
  switch (action.type) {
    case ActionType.CLEAR:
      draft = {};
      return;
    case ActionType.INIT:
      draft = Object.assign({}, action.data);
      draft.response = {};
      return;
    case ActionType.PLAY:
      draft.queue.push(action.data.name);
      return;
    case ActionType.REGISTER:
      console.log("register!");
      draft.assets[action.data.id!] = action.data.ref;
      return;
  }
};

/**
 * Media Player hook.
 *
 * Responsible for coordinating playback across all media within a question to
 * ensure only one element is playing at a time.
 *
 */
export const useMediaPlayer = () => {
  const media = useContext(AudioContext);

  const play = (id: string) => {
    return new Promise((resolve, reject) => {
      let audio = media.assets[id].current;
      audio.onended = resolve;
      audio.focus();
      audio.play();
    });
  };

  const playAll = async () => {
    console.log("play all", media);
    // Object.keys(media.assets).map(async (key: any) => {
    //   await play(key);
    // });

    Object.keys(media.assets).reduce(
      async (previousPromise: any, nextID: any) => {
        await previousPromise;
        return play(nextID);
      },
      Promise.resolve(),
    );
  };

  return {
    media,
    playAll,
  };
};
